var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"goods-category page pd4 list-page"},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.tree,"node-key":"id","default-expand-all":true,"expand-on-click-node":false,"props":_vm.treeProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }